import React from 'react';
import styles from './CompactPageLayout.module.scss';
import IconBack from 'assets/svg/Arrow-grey.svg';

const cx = (...classes: (string | undefined | null | false)[]) => classes.filter(Boolean).join(' ');

interface CompactPageLayoutProps {
    title: string;
    onBack?: () => void;
    middleContent?: React.ReactNode;
    headerButtons?: React.ReactNode;
    contentAreaClassName?: string;
    pageWrapperClassName?: string;
    headerClassName?: string;
    headerButtonsClassName?: string;
    afterContent?: React.ReactNode;
    children: React.ReactNode;
}

const CompactPageLayout: React.FC<CompactPageLayoutProps> = ({
    title,
    onBack,
    middleContent,
    headerButtons,
    contentAreaClassName,
    pageWrapperClassName,
    headerClassName,
    headerButtonsClassName,
    afterContent,
    children,
}) => {
    return (
        <div className={cx(styles.pageWrapper, pageWrapperClassName)}>
            <div className={cx(styles.compactHeader, headerClassName)}>
                
                <h1 className={styles.compactTitle}>
                    {onBack && <img src={IconBack} className={styles.backIcon} onClick={onBack} alt="" />}
                    {title}
                </h1>
                {middleContent}
                {headerButtons && (
                    <div className={cx(styles.headerButtons, headerButtonsClassName)}>{headerButtons}</div>
                )}
            </div>
            <div className={cx(styles.contentArea, contentAreaClassName)}>
                {children}
            </div>
            {afterContent}
        </div>
    );
};

export default CompactPageLayout;
